import React from 'react';
import {Outlet} from 'react-router-dom';
import AppHeader from './AppHeader';
import AppFooter from './AppFooter';

// 带页头/页脚的标准页面外壳
export default function Layout () {
    return (
        <>
            <a className="cq-skip-link" href="#main-content">跳到主要内容</a>
            <AppHeader />
            <main id="main-content" tabIndex={-1}>
                <Outlet />
            </main>
            <AppFooter />
        </>
    );
}
